import { useCallback } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { StudioTextInput } from 'apps/studio/components/shared/inputs/StudioTextInput'
import { getAdditionalProps } from 'apps/studio/components/settings/inputs'

export const SettingsTextAreaInput = ({
  property,
  label,
  id,
  data,
  update,
  additionalClasses,
  validationFunction, // TODO: Should probably apply this to all inputs / find a better solution for validation such as using Redux middleware
  additionalProps = {},
  iconComponent = null,
  placeholder = '',
}) => {
  const dispatch = useDispatch()
  const store = useStore()
  const { [property]: value, id: dataId } = data


  const memoizedOnChange = useCallback(
    updatedValue => {
      dispatch(
        update({
          [property]: validationFunction
            ? validationFunction(dataId, updatedValue, store.getState())
            : updatedValue,
        })
      )
    },
    [value, dispatch, update, property, validationFunction, dataId, store]
  )

  return (
    <StudioTextInput
      id={id}
      label={label}
      placeholder={placeholder}
      value={value || ''}
      onChange={memoizedOnChange}
      additionalClasses={additionalClasses}
      additionalProps={getAdditionalProps(additionalProps, data)}
      settingType="longTextInput"
      IconComponent={iconComponent}
    />
  )
}
